<template>
    <section>
        <div ref="hashtagTree" :id="id"></div>
    </section>
</template>

<script>
    import Vue from 'vue'
    import 'jsit'
    import Chance from 'chance'

    const change = new Chance()
    const $jit = window.$jit

    export default {
        name: 'HashtagTree',
        props: {
            hashtags: {
                default: {},
                type: Object
            }
        },
        data () {
            return {
                id: change.guid(),
                hashtagTree: {}
            }
        },
        watch: {
            hashtags (hashtags) {
                this.hashtagTree.loadJSON(hashtags)
                this.hashtagTree.refresh()
            }
        },
        created () {
            Vue.nextTick().then(() => {
                const hashtagTree = this.$refs.hashtagTree
                const ht = this.hashtagTree = new $jit.RGraph({
                    // id of the visualization container
                    injectInto: hashtagTree,
                    // canvas width and height
                    width: 300,
                    height: 300,
                    duration: 750,
                    // Change node and edge styles such as
                    // color, width and dimensions.
                    Node: {
                        dim: 3,
                        color: '#ad0000'
                    },
                    Edge: {
                        overridable: true,
                        lineWidth: 1,
                        color: '#ddd'
                    },
                    label: {
                        type: 'HTML'
                    },
                    // Attach event handlers and add text to the
                    // labels. This method is only triggered on label
                    // creation
                    onCreateLabel: (domElement, node) => {
                        domElement.innerHTML = '#' + node.name
                        domElement.className = domElement.className + ' ' + node.data.class
                        $jit.util.addEvent(domElement, 'click', () => {
                            ht.onClick(node.id, {
                                onComplete: () => {
                                    ht.controller.onComplete()
                                }
                            })
                        })
                    },
                    onBeforePlotLine: (adj) => {
                        if (adj.nodeTo.data.frequency > 30) {
                            adj.data.$lineWidth = 3
                            adj.data.$color = '#b0b0b0'
                        } else if (adj.nodeTo.data.frequency > 5) {
                            adj.data.$lineWidth = 2
                            adj.data.$color = '#c6c6c6'
                        } else {
                            adj.data.$lineWidth = 1
                            adj.data.$color = '#dddddd'
                        }
                    },
                    // Change node styles when labels are placed
                    // or moved.
                    onPlaceLabel: (domElement, node) => {
                        const style = domElement.style
                        style.display = ''
                        style.cursor = 'pointer'
                        if (node._depth <= 1) {
                            style.fontSize = '0.8em'
                        } else if (node._depth === 2) {
                            style.fontSize = '0.7em'
                        } else {
                            style.display = 'none'
                        }

                        const left = parseInt(style.left)
                        const w = domElement.offsetWidth
                        style.left = (left - w / 2) + 'px'
                    },
                    onComplete: () => {
                        console.log('done')
                    }
                })
                // load JSON data.
                ht.loadJSON(this.hashtags)
                // compute positions and plot.
                ht.refresh()
            })
        }
    }
</script>

<style>
    div[id*="canvaswidget"] {
        margin-left: auto;
        margin-right: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/HashtagTree.vue